function initSlick() {
  $('.bannerSlider').not('.slick-initialized').slick({
    dots: false,
    arrows: false,
    infinite: true,
    speed: 1200,
    autoplay: true,
    autoplaySpeed: 3000,
    fade: true,
    cssEase: 'ease-in-out',
    pauseOnHover: false
  });
}

document.addEventListener("DOMContentLoaded", initSlick);
document.addEventListener("shopify:section:load", initSlick);



